import { render, staticRenderFns } from "./po_create.vue?vue&type=template&id=643acdfb&scoped=true&"
import script from "./po_create.vue?vue&type=script&lang=js&"
export * from "./po_create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643acdfb",
  null
  
)

export default component.exports